import { ParameterType } from '@/study-search/enums';
import { DegreeTypeFilterOptionValue, DurationFilterOptionValue } from '@studyportals/search-filters/server-side';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class CountryDegreeTypeOneYearRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 3 &&
			indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			indexableFilters.some(
				(_) =>
					_.type === ParameterType.DEGREE_TYPE &&
					_.values.length === 1 &&
					(_.values[0] as DegreeTypeFilterOptionValue === DegreeTypeFilterOptionValue.MBA || _.values[0] as DegreeTypeFilterOptionValue === DegreeTypeFilterOptionValue.MSC),
			) &&
			indexableFilters.some(
				(_) => _.type === ParameterType.DURATION && _.values.length === 1 && _.values[0] as DurationFilterOptionValue === DurationFilterOptionValue.ONE_YEAR,
			)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.COUNTRY_DEGREE_TYPE_DURATION_ROUTE,
			params: {
				country: this.extractPath(filters.find((_) => _.type === ParameterType.COUNTRY)),
				degree_type: this.extractPath(filters.find((_) => _.type === ParameterType.DEGREE_TYPE)),
				duration: this.extractPath(filters.find((_) => _.type === ParameterType.DURATION)),
			},
		};
	}
}
